import { styled } from '@mui/material'
import Tab from '@mui/material/Tab'
import { colors } from '@theme/variables'

export const TabsCarouselWrapper = styled('div')`
  display: flex;
  align-items: center;
`

export const TabsContainer = styled('div')`
  overflow: hidden;
  margin-left: -10px;
`

export const TabItem = styled(Tab)<{ $isSelected?: boolean; $isDisabled?: boolean }>`
  min-width: 10px !important;
  margin: 0 5px;

  ${({ $isSelected }) =>
    $isSelected
      ? `
          color: ${colors.primary} !important;
        `
      : ''}
  ${({ $isDisabled }) =>
    $isDisabled
      ? `
          opacity: 0.2;
          pointer-events: none;
        `
      : ''}

  &.Mui-selected {
    margin: 0 15px;
  }
`

export const RightIconTriangle = styled('div')`
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-left: 18px solid ${colors.primary};
  margin-left: 12px;
  cursor: pointer;
  &:active {
    border-left: 18px solid ${colors.primaryDark};
  }
`

export const LeftIconTriangle = styled(RightIconTriangle)`
  transform: rotate(180deg);
  margin-right: 12px;
  margin-left: 0;
`

export const LeftButton = styled('div')`
  display: flex;
  align-items: center;
  height: 27px;
  border-right: 1px solid #cecece;
  margin-right: 15px;
`

export const RightButton = styled('div')`
  border-right: none;
  border-left: 1px solid #cecece;
  margin-right: 12px;
`
export const DropArea = styled('div')`
  padding: 1.5px 9px;
  border: 1px solid transparent;
  font-size: 15px;
`

export const TabContent = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const TabLabel = styled('div')``

export const TabBadge = styled('div')`
  background: ${colors.pink};
  height: 18px;
  min-width: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  line-height: 11px;
  font-weight: 700;
  color: ${colors.white};
  padding: 0 5px;
`
